/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetChildsByParentIdQuery } from '../../models/get-childs-by-parent-id-query';
import { GetChildsByParentIdQueryResult } from '../../models/get-childs-by-parent-id-query-result';

export interface ApiCommonStackholdersGetChildsByParentIdPost$Params {
      body?: GetChildsByParentIdQuery
}

export function apiCommonStackholdersGetChildsByParentIdPost(http: HttpClient, rootUrl: string, params?: ApiCommonStackholdersGetChildsByParentIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetChildsByParentIdQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiCommonStackholdersGetChildsByParentIdPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetChildsByParentIdQueryResult>;
    })
  );
}

apiCommonStackholdersGetChildsByParentIdPost.PATH = '/api/Common/Stackholders/GetChildsByParentId';
